import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';
import { IFile } from '@shared/model/basic-data';

export const selectFiles = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState.files,
);

export const selectAdditionalDataFiles = createSelector(selectFiles, (files: IFile[]) =>
  files.length ? files.filter((file: IFile) => file.file_type === 1) : [],
);

export const selectAdditionalFiles = createSelector(selectFiles, (files: IFile[]) =>
  files.length ? files.filter((file: IFile) => file.file_type === 0) : [],
);
